import './statusbar.less';

import { Statusbar } from 'framework7-react';


export default Statusbar;
